import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { recordLandingActivity, recordSignupActivity } from "@faire/retailer-visitor-shared/actions/user/recordLoggedOutActivity";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { KeepExploringCarousel } from "@faire/retailer-visitor-shared/components/KeepExploringCarousel";
import { LazyLoggedOutMobileSignUpSnackbar } from "@faire/retailer-visitor-shared/components/LoggedOutMobileSignUpSnackbar/index";
import { SignUpBanner } from "@faire/retailer-visitor-shared/components/SignUpBanner/SignUpBanner";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useCategoryPageScroll } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageScroll";
import { LoggedOutCategoryPageAboveFold } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/LoggedOutCategoryPageAboveFold";
import { LoggedOutCategoryPageBrandReviewsCarousel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageBrandReviewsCarousel";
import { LoggedOutCategoryPageFAQs } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageFAQs/LoggedOutCategoryPageFAQs";
import { LoggedOutCategoryPageMoreInC3Pills } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageMoreInC3Pills/LoggedOutCategoryPageMoreInC3Pills";
import { LoggedOutCategoryPageRelatedSearches } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageRelatedSearches";
import { LoggedOutCategoryPageSeoTextBlock } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageSeoTextBlock";
import { LoggedOutCategoryPagePagination } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageFilterAndResults/LoggedOutCategoryPagePagination";
import { LoggedOutCategoryPageLayoutElements } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/LoggedOutCategoryPageLayoutElements";
import { VisibilityTracker } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/VisibilityTracker";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { LoggedOutCategoryPageWrapper } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/styles/LoggedOutCategoryPageStyles";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackCategoriesResultsScreenView } from "@faire/web-api--source/events/categories/view/resultsScreen";
import { trackSignupModalOpenCatnavBottomCtaClick } from "@faire/web-api--source/events/signup/click/modalOpenCatnavBottomCta";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import React, { Suspense, useEffect } from "react";
import { useHistory } from "react-router-dom";
export var LoggedOutCategoryPageBase = function(param) {
    var categoryPageLoadTimingRef = param.categoryPageLoadTimingRef;
    var history = useHistory();
    var categoryModel = useLoggedOutCategoryPageCurrentCategory();
    var navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
    var scrollToTop = useCategoryPageScroll().scrollToTop;
    var handleSignUp = function() {
        return popSignUp(history, SignUpType.GENERIC, trackSignupModalOpenCatnavBottomCtaClick, {
            element: SignUpElement.BELOW_FOLD,
            sourceId: "logged_out_category_page_signup_banner"
        });
    };
    useEffect(function() {
        recordLandingActivity({
            category_path_identifier: categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier
        }, history);
        try {
            recordSignupActivity({
                category_path_identifier: categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier
            }, getLocationOrThrow().pathname);
        } catch (e) {
        // If there's no window.location don't record
        }
    }, [
        categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier,
        history
    ]);
    useEffect(function() {
        trackCategoriesResultsScreenView(navigationPath);
    }, [
        navigationPath
    ]);
    if (!categoryModel) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(LoggedOutCategoryPageAboveFold, {
                        categoryPageLoadTimingRef: categoryPageLoadTimingRef
                    }),
                    /*#__PURE__*/ _jsx(LoggedOutCategoryPagePagination, {
                        scrollToTop: scrollToTop
                    }),
                    /*#__PURE__*/ _jsxs(LoggedOutCategoryPageWrapper, {
                        $noPaddingOnMobile: true,
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "5x"
                            }),
                            /*#__PURE__*/ _jsxs(WhenVisibilityIsImminent, {
                                children: [
                                    /*#__PURE__*/ _jsx(LoggedOutCategoryPageLayoutElements, {
                                        placement: ILayoutElement.Placement.BOTTOM
                                    }),
                                    /*#__PURE__*/ _jsx(LoggedOutCategoryPageMoreInC3Pills, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsx(LoggedOutCategoryPageRelatedSearches, {}),
                            /*#__PURE__*/ _jsx(LoggedOutCategoryPageBrandReviewsCarousel, {}),
                            /*#__PURE__*/ _jsx(VisibilityTracker, {
                                name: "keep-exploring-carousel",
                                children: /*#__PURE__*/ _jsx(KeepExploringCarousel, {
                                    dataTestId: "logged-out-category-keep-exploring",
                                    clickTrackPath: "logged-out-category/keep-exploring-carousel",
                                    removeCategoryPath: categoryModel.pathIdentifier,
                                    onClick: function() {
                                        var _getWindowOrThrow_scrollTo, _getWindowOrThrow;
                                        (_getWindowOrThrow_scrollTo = (_getWindowOrThrow = getWindowOrThrow()).scrollTo) === null || _getWindowOrThrow_scrollTo === void 0 ? void 0 : _getWindowOrThrow_scrollTo.call(_getWindowOrThrow, 0, 0);
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsx(LoggedOutCategoryPageFAQs, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx(VisibilityTracker, {
                        name: "signup-banner",
                        children: /*#__PURE__*/ _jsx(SignUpBanner, {
                            onClick: handleSignUp
                        })
                    }),
                    /*#__PURE__*/ _jsx(LoggedOutCategoryPageSeoTextBlock, {}),
                    /*#__PURE__*/ _jsx(Footer, {})
                ]
            }),
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyLoggedOutMobileSignUpSnackbar, {})
            })
        ]
    });
};
